export default team => {
  if (team.constructor !== Object) {
    throw new TypeError('team has to be an object.')
  }

  return team.visibility === 'is_personal'
    ? `${team.name} (Personal)`
    : team.name
}



// WEBPACK FOOTER //
// ./src/filters/teamName.js